import React from 'react'
import { StaticQuery, graphql } from 'gatsby'
import PageTransition from 'gatsby-plugin-page-transitions'
import Layout from '../components/layout'
import Page from '../components/Page'

const ThirdPage = ({ transition, data }) => {
  return (
    <Layout>
      <Page
        transition={transition}
        animation={false}
        bg={data.datoCmsPage.background ? data.datoCmsPage.background.url : ''}
        align={data.datoCmsPage.alignment}
        hotspots={data.datoCmsPage.treeChildren}
        hotspotLabel={true}
        logoColor={data.datoCmsPage.logoColor}
        icon={data.datoCmsPage.icon}
        backLink={
          data.datoCmsPage.treeParent ? data.datoCmsPage.treeParent.slug : '/'
        }
        backLinkX={data.datoCmsPage.backLinkX}
        backLinkY={data.datoCmsPage.backLinkY}
        backButton={true}
        lvl={1}
        menuData={{ sub: true, ...data.menuData }}
        currentSlug={data.datoCmsPage.treeParent.slug}
      />
    </Layout>
  )
}

export default ThirdPage

export const query = graphql`
  query Page3Query($slug: String) {
    datoCmsPage(slug: { eq: $slug }) {
      title
      slug
      displayTitle
      icon {
        url
      }
      menuIcon {
        url
      }
      backLink {
        slug
      }
      backLinkX
      backLinkY
      background {
        url
      }
      alignment
      logoColor
      treeParent {
        menuIcon {
          url
        }
        slug
        attachments {
          __typename
          ... on DatoCmsVideo {
            title
            videoUrl
            thumbnail {
              url
              width
              height
            }
          }
        }
        treeChildren {
          title
          displayTitle
          slug
          treeChildren {
            title
            displayTitle
            slug
          }
        }
      }
      treeChildren {
        title
        displayTitle
        hotspotX
        hotspotY
        slug
        icon {
          url
        }
        treeChildren {
          title
          displayTitle
          slug
        }
      }
    }
    menuData: datoCmsPage(root: { eq: true }) {
      treeChildren {
        displayTitle
        slug
        menuIcon {
          url
        }
        treeChildren {
          displayTitle
          slug
          treeChildren {
            displayTitle
            slug
          }
        }
      }
    }
  }
`
